module.exports = __webpack_public_path__ + "media/images/front/img_user-854eef1cf8292891e30648ef5b0eaf9c.jpg";